module.exports = __webpack_public_path__ + "img/zh_CN-box4-text-light.45acc814.png";